import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../../../../hooks'
import { FormikField } from '../../../../../../../Formik'
import { InputField } from '../../../../../../../Input'
import {
  APPLICANT_IDENTITY_FIELD_NAME_NAME,
  APPLICANT_IDENTITY_NAME_MAX_LENGTH,
  QA_NAME_APPLICANT_IDENTITY_NAME_INPUT,
} from '../../../ApplicantIdentityWidget.constants'

function ApplicantIdentityNameField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      autoFocus
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('RentalPortal.ApplicantProfileIdentityNameLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={APPLICANT_IDENTITY_NAME_MAX_LENGTH}
      name={APPLICANT_IDENTITY_FIELD_NAME_NAME}
      placeholder={t('RentalPortal.ApplicantProfileIdentityNamePlaceholderKey')}
      qaName={QA_NAME_APPLICANT_IDENTITY_NAME_INPUT}
    />
  )
}

export default ApplicantIdentityNameField
